
class EmboltAPI {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
  }

  get apiHeaders() {
    const apiHeaders = {
      'Content-Type': 'application/json',
    }

    if (this.csrfToken) {
      apiHeaders['X-CSRF-Token'] = this.csrfToken;
    }

    return apiHeaders;
  }
}

export { EmboltAPI };